import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { SocialProof } from "./components/SocialProof";
import { TrainingStrategy } from "./components/TrainingStrategy";
import { Programs } from "./components/Programs";
import { Domains } from "./components/Domains";
import { WhyUs } from "./components/WhyUs";
import { Process } from "./components/Process";
import { Mentors } from "./components/Mentors";
import { FAQ } from "./components/FAQ";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";
import { PersistentCTA } from "./components/PersistentCTA";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Hero />
        <SocialProof />
        <TrainingStrategy />
        <Programs />
        <Domains />
        <WhyUs />
        <Process />
        <Mentors />
        <FAQ />
        <CTA />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
